import {Tab, TabGroup, TabList, TabPanel, TabPanels} from '@headlessui/react'
import {useCallback} from '@wordpress/element'
import {BaseProps} from "../types";

type TeamBlockProps = {
  manager_title: string
  staff_title: string
  leaders: any[]
  teachers: any[]
}

export default function TeamBlock(props: BaseProps<TeamBlockProps>) {
  const { manager_title, staff_title, leaders = [], teachers = [] } = props.data || {}

  const renderTabList = useCallback(() => {
    return (
      <TabList className={'flex flex-col lg:flex-row justify-center items-center lg:space-x-[375px] mb-[70px] space-y-3 lg:space-y-0'}>
        <Tab className={'data-[selected]:underline data-[selected]:text-primary outline-none'}>
          { manager_title || 'BAN LÃNH ĐẠO' }
        </Tab>
        <Tab className={'data-[selected]:underline data-[selected]:text-primary outline-none'}>
          { staff_title || 'ĐỘI NGŨ GIẢNG VIÊN' }
        </Tab>
      </TabList>

    )
  }, [])

  const renderTabPanel = useCallback((data: any[]) => {
    if (!Array.isArray(data)) return null
    return (
      <div className="flex justify-center">
        <div className="flex flex-wrap justify-center">
          {
            data.map((item, index) => (
              <div key={index}
                className="border my-[10px] mx-[10px] xl:w-[350px] 2xl:w-[420px] justify-center items-center min-w-[116px] rounded-[10px] overflow-hidden bg-blue-50">
                <div className="flex justify-center h-[252px] bg-white">
                  <img className="h-[252px] object-cover" alt="" src={item.avatar || item.image_url} />
                </div>
                <div className="text-center font-exo p-4 2xl:p-10">
                  <div className="font-bold text-subtitle relative text-primary flex justify-center items-center">
                    { item.name }
                  </div>
                  <div className="text-primary text-subtitle italic">
                    { item.title }
                  </div>
                  <div dangerouslySetInnerHTML={{ __html: item.description }}></div>
                </div>
              </div>
            ))
          }
        </div>
      </div>
    )
  }, [])

  if (!props.data) return null

  return (
    <TabGroup>
      {renderTabList()}
      <TabPanels>
        <TabPanel>
          {renderTabPanel(leaders)}
        </TabPanel>
        <TabPanel>
          {renderTabPanel(teachers)}
        </TabPanel>
      </TabPanels>
    </TabGroup>
  )
}